import { useEffect } from 'react'
import { Redirect, Route, useParams } from 'react-router-dom'
import { unifiedFlowPaths } from 'app/navigation/paths'
import CustomSwitch from 'app/router/Switch'

import ErrorPage from 'common/components/error/ErrorPage'
import Spinner from 'common/components/spinner'
import { useAppDispatch, useAppSelector } from 'common/hooks/redux'

import useGetContentQuery from '../api/queries/useGetContentQuery'
import {
  resetContentPageState,
  unifiedContentInitialize,
} from '../store/unifiedFlowSlice'

import { BRIEF_ELEMENT_ID } from './brief/leftSection/ElementsList'
import Header from './components/header/Header'
import Approvals from './approvals'
import Brief from './brief'
import Generate from './generate'
import Integrations from './integrations'
import Results from './results'

const ContentPage = () => {
  const dispatch = useAppDispatch()
  const { contentId } = useParams<{ contentId: string }>()
  const activeContentId = useAppSelector(
    (state) => state.unifiedFlow.activeContentId
  )
  const selectedElementId = useAppSelector(
    (state) => state.unifiedFlow.selectedElementId
  )

  const { status, data: content } = useGetContentQuery(contentId)

  useEffect(() => {
    const getElementId = (): string | number => {
      return BRIEF_ELEMENT_ID // TODO: Implement this later, for now just return BRIEF_ELEMENT_ID
    }
    if (content && !activeContentId && !selectedElementId) {
      const elementId = getElementId()

      dispatch(
        unifiedContentInitialize({
          activeContentId: contentId,
          selectedElementId: elementId,
        })
      )
    }
  }, [activeContentId, content, contentId, dispatch, selectedElementId])

  useEffect(() => {
    return () => {
      dispatch(resetContentPageState())
    }
  }, [dispatch])

  const getState = () => {
    if (status === 'error') {
      return 'error'
    } else if (!!content && !!activeContentId && !!selectedElementId) {
      return 'success'
    } else {
      return 'loading'
    }
  }

  const state = getState()

  return (
    <>
      {
        {
          loading: <Spinner />,
          success: (
            <>
              <Header />
              <CustomSwitch>
                <Route
                  key="unified-flow-content-brief"
                  path={unifiedFlowPaths.brief}
                  exact
                >
                  <Brief />
                </Route>
                <Route
                  key="unified-flow-content-generate"
                  path={unifiedFlowPaths.generate}
                  exact
                >
                  <Generate />
                </Route>
                <Route
                  key="unified-flow-content-approvals"
                  path={unifiedFlowPaths.approvals}
                  exact
                >
                  <Approvals />
                </Route>
                <Route
                  key="unified-flow-content-integrations"
                  path={unifiedFlowPaths.integrations}
                  exact
                >
                  <Integrations />
                </Route>
                <Route
                  key="unified-flow-content-results"
                  path={unifiedFlowPaths.results}
                  exact
                >
                  <Results />
                </Route>
                <Redirect
                  exact
                  from={unifiedFlowPaths.content}
                  to={unifiedFlowPaths.brief}
                />
              </CustomSwitch>
            </>
          ),
          error: <ErrorPage />,
        }[state]
      }
    </>
  )
}

export default ContentPage
